import {useEffect} from 'react'
import {useAuth, setLogoutHandler} from '../../modules/auth'

const SetupTokenExpireNavigate = () => {
  const {logout, logoutAsTokenGone} = useAuth()

  useEffect(() => {
    setLogoutHandler(logoutAsTokenGone)
  }, [logoutAsTokenGone])

  return null
}

export default SetupTokenExpireNavigate
